export const InitialState={
       page:'MAIN'
}